<template ref="thdsm">
    <div class="form-group row" v-if="this.selected_transductor !== undefined">
        <label for="COMBO_transductor" class="col-md-2 col-form-label text-md-right">Transductor</label>
        <div class="col-md-9">
            <div class="row">
                <div class="input-group col-11">
                    <select ref="id_transductor" name="transductor" id="COMBO_transductor"
                        class="form-control" data-live-search="true" data-size="5"
                        @change="setTransductor" v-model="selected_transductor">
                        <option value="T">Todos</option>
                        <option v-for="(transductor, index) in transductores" v-bind:value="transductor.id" :key="index">
                            {{ transductor.name }}
                        </option>
                    </select>
                </div>
                <span id="span_COMBO_transductor" class="my-auto" aria-hidden="true"></span>
            </div>
            <div id="div_COMBO_transductor" class="form-text text-danger"></div>
            <div class="form-text text-danger"></div>
        </div>
    </div>
    <div class="form-group row" v-else>
        <label for="OCOMB_transductor" class="col-md-2 col-form-label text-md-right">Transductor</label>
        <div class="col-md-9">
            <div class="row">
                <div class="input-group col-11">
                    <select ref="id_transductor" name="transductor" id="OCOMB_transductor"
                        class="form-control" data-live-search="true" data-size="5"
                        @change="validar">
                        <option value="">Indica si tiene transductor</option>
                        <option v-for="(transductor, index) in transductores" v-bind:value="transductor.id" :key="index">
                            {{ transductor.name }}
                        </option>
                    </select>
                </div>
                <span id="span_OCOMB_transductor" class="my-auto" aria-hidden="true"></span>
            </div>
            <div id="div_OCOMB_transductor" class="form-text text-danger"></div>
            <div class="form-text text-danger"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        valtransductor: {
        type: Number,
        },
  },
    data: function () {
        return {
            transductores: [],
            selected_transductor:-1,
        };
    },
    mounted() {
        this.loadTransductor();
        this.setTransductor();
    },
    methods: {
        validar() {
            validar(document.formulario);
            $('.selectpicker').selectpicker('refresh');
        },
        loadTransductor() {
            axios.get("/api/transductor/all").then((response) => {
                this.transductores = response.data;
                validar(document.formulario);
            });
            this.selected_transductor = this.valtransductor;
        },
        setTransductor() {
            this.$emit("getTransductor", this.selected_transductor);
            validar(document.formulario);
        },
    }
};
</script>